<template>
  <div class="order_payment">
    <el-image
      ref="elimg"
      style="width: 129px; height: 129px; position: absolute; left: -90000px;z-index: 10086;"
      :src="srcList[imgindex]"
      :preview-src-list="srcList"
      :z-index="imgindex"
    >
      <!-- :src="item.imgUrl" -->
    </el-image>
    <div class="commodity_list">
      <div class="step_title">商品列表</div>
      <div class="com_items">
        <div class="btn right-btn" @click="navNext" v-if="srcList.length>=7">
          <i class="iconfont iconbiaodan_rili_right"></i>
        </div>
        <div class="btn left-btn" @click="navPrev" v-if="srcList.length>=7">
          <i class="iconfont iconbiaodan_rili_left"></i>
        </div>

        <!-- <div class="commodity_item" v-for="(item, index) in orderList"> -->
        <div class="commodity_item" ref="dataNavList">
          <div
            class="dataNavListItem"
            v-for="(item, index) in orderList"
            :style="{ transform: 'translateX(-' + move + 'px)' }"
          >
            <img
              style="width: 129px; height: 129px; cursor: pointer"
              :src="item.imgUrl"
              @click="imgPreview(index)"
              alt=""
            />
            <div
              style="
                margin-top: 8px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
              "
            >
              {{ item.name || "暂无" }}
            </div>
            <span>X{{ item.count || "0" }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="order_pay" style="margin-top: 10px">
      <div class="step_title">
        订单支付
        <span>
          请在
          <span class="time">24小时</span> 内完成支付, 超时后将取消订单
        </span>
      </div>
      <div class="pay">
        <div class="pay_modes">
          <div
            v-if="isShow('WALLET')"
            class="pay_mode"
            :class="{ pay_selected: payMode[0].selected }"
            @click="payMethod('WALLET')"
          >
            <svg class="icon icona_xiadan_yue" aria-hidden="true">
              <use xlink:href="#icona_xiadan_yue" />
            </svg>
            <div class="pay_mode_right">
              余额支付
              <div class="yue_money">余额：¥{{ balance }}</div>
            </div>
          </div>

          <!-- 支付宝支付暂时隐藏 -->
          <div
            v-if="isShow('ALIPAY')"
            class="pay_mode"
            :class="{ pay_selected: payMode[1].selected }"
            @click="payMethod('ALIPAY')"
          >
            <svg class="icon icona_xiadan_weixin" aria-hidden="true">
              <use xlink:href="#icona_xiadan_weixin" />
            </svg>
            <div class="pay_mode_right">支付宝支付</div>
          </div>

          <div
            v-if="isShow('WECHAT')"
            class="pay_mode"
            :class="{ pay_selected: payMode[2].selected }"
            @click="payMethod('WECHAT')"
          >
            <svg class="icon icona_xiadan_zhifubao" aria-hidden="true">
              <use xlink:href="#icona_xiadan_zhifubao" />
            </svg>
            <div class="pay_mode_right">微信支付</div>
          </div>
        </div>
        <!-- <div class="qrcode" v-if="!paying">
          <img :src="qrcode" alt />
          <div>
            请使用
            <span>微信</span>扫码支付
          </div>
        </div>-->
        <div class="qrcode" v-if="payMode[2].selected">
          <img :src="qrcode" alt />
          <div>
            请使用
            <span>微信</span>扫码支付
          </div>
        </div>
        <div class="pay_total">
          应付总额：
          <span class="total_text">¥{{ $store.state.priceList.totalFee }}</span>
        </div>

        <el-button class="payment" v-if="paying" @click="payClick()"
          >立即支付</el-button
        >
      </div>
    </div>

    <el-dialog title="输入密码支付" :visible.sync="dialogVisible" width="30%">
      <div class="com_login">
        <el-input
          v-model="verificationCode"
          placeholder="请输入支付密码"
          maxlength="6"
          show-password
          autocomplete="new-password"
          @focus="icon = true"
          @blur="verificationCode == '' ? (icon = false) : (icon = true)"
        ></el-input>
          <!-- :type="passwordType" -->
        <div class="errpassword" v-if="errText">密码错误</div>
        <!-- <svg
          class="icon"
          aria-hidden="true"
          v-show="icon && passwordType == 'password'"
          @click="passType(passwordType)"
        >
          <use xlink:href="#icontanchuang_guanbichakan" />
        </svg>
        <svg
          class="icon"
          aria-hidden="true"
          v-show="icon && passwordType == 'text'"
          @click="passType(passwordType)"
        >
          <use xlink:href="#icontanchuang_chakn" />
        </svg> -->
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="clickPay()"
          :disabled="!verificationCode"
          :loading="loading"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="订单支付"
      :visible.sync="orderPay"
      width="30%"
      class="zfmima"
    >
      <div>是否已支付成功？</div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="orderPay = false">取 消</el-button>
        <el-button type="primary" @click="openOrderList()">确 定</el-button>
      </span>
    </el-dialog>
    <set-passwod
      :showPad="showPad"
      :phoneNum="phoneNum"
      v-on:showPasswod="showPasswod"
    ></set-passwod>
    <el-dialog
      title="订单支付打开失败"
      :visible.sync="ispayHtml"
      width="423"
      class="payHtmlNo"
      @closed="payHtmlClose"
    >
      <div class="payHtmlNo-main">
        <div class="payHtmlNo-note">请复制下方链接在新窗口打开进行支付</div>
        <div class="payHtmlNo-url">{{ pathStr }}</div>
        <div class="payHtmlNo-copy" @click="copyUrl">复制链接</div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="ispayHtml = false">取消</el-button>
        <el-button type="primary" @click="ispayHtml = false">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Bus from "@/utils/bus.js";
import setPasswod from "./set_passwod";
import Clipboard from "clipboard";
export default {
  components: {
    setPasswod,
  },
  data() {
    return {
      payMode: [
        { selected: true, name: "WALLET" },
        { selected: false, name: "ALIPAY" },
        { selected: false, name: "WECHAT" },
      ],
      verificationCode: "",
      dialogVisible: false,
      passwordType: "password",
      icon: false,
      balance: 0,
      payWayEnum: "WALLET", //支付方式
      payPassword: false,
      getYzm: true,
      yzmTime: 60,
      yzmTtext: "发送验证码",
      errText: false,
      orderList: [],
      zfbHtml: "",
      paying: true,
      qrcode: "",
      orderPay: false,
      showPad: false,
      phoneNum: "",
      cycle: "",
      loading: false,
      ispayHtml: false,
      pathStr: "",
      orderPayWay: [],
      srcList: [],
      // srcList: [
      //   "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
      //   "https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg",
      //   "https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg",
      //   "https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg",
      //   "https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg",
      //   "https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg",
      //   "https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg",
      //   "https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg",
      //   "https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg",
      //   "https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg",
      //   "https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg",
      //   "https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg",
      //   "https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg",
      //   "https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg",
      // ],
      move: 0,
      dataNavListRealWidth: 0,
      dataNavListViewWidth: 0,
      imgindex: 0,
    };
  },
  activated() {
    this.$store.state.priceList.totalFee=0
    var data = {
      url: "orderPayment",
      step: 0,
    };
    Bus.$emit("val", data);

    var _this = this;
    this.$fetch(`/user/api/customer/balance`).then((res) => {
      if (res.code == 0) {
        _this.balance = res.data.balance;
      } else {
        this.$message(res.message);
      }
    });
    this.$fetch(`/order/api/order/${_this.$route.query.orderid}`).then(
      (res) => {
        if (res.code == 0) {
          _this.orderList = res.data.orderItems;
          _this.$store.state.priceList.totalFee = res.data.totalAmount;
          this.srcList = this.orderList.map(i=>i.imgUrl);
        } else {
          this.$message(res.message);
        }
      }
    );
    // 获取可用支付方式
    this.$fetch(`/common/platform/get_pay_way`).then((res) => {
      if (res.code == 0) {
        this.orderPayWay = res.data.orderPayWay;
        // 设置默认支付方式
        this.payMethod(res.data.orderPayWay[0]);
      } else {
        this.$message(res.message);
      }
    });
  },
  mounted() {
    // scrollWidth获取整个菜单实际宽度
    this.dataNavListRealWidth = this.$refs.dataNavList.scrollWidth;
    // offsetWidth获取菜单在当前页面可视宽度
    this.dataNavListViewWidth = this.$refs.dataNavList.offsetWidth;
    //实际宽度减去可视宽度就是可移动的范围即move的范围
    // 窗口大小变化时触发。实时更新可视宽度
    window.onresize = () => {
      return (() => {
        this.dataNavListViewWidth = this.$refs.dataNavList.offsetWidth;
        //注1，详见下方
        if (
          this.move >
          this.dataNavListRealWidth - this.dataNavListViewWidth - 145
        ) {
          this.move = this.dataNavListRealWidth - this.dataNavListViewWidth;
        }
      })();
    };
  },
  methods: {
    // 是否显示
    isShow(item) {
      if (this.orderPayWay.indexOf(item) != -1) {
        return true;
      } else {
        return false;
      }
    },
    // 跳转订单列表
    openOrderList() {
      this.$router.push({ name: "allOrder" });
    },
    showPasswod(val) {
      this.showPad = val;
    },
    // 支付方式
    payMethod(item) {
      for (let i of this.payMode) {
        i.selected = false;
        if (item == i.name) {
          i.selected = true;
        }
      }
      this.payWayEnum = item;
      if (item == "WALLET" || item == "ALIPAY") {
        clearInterval(this.cycle);
        this.paying = true;
      }
      if (item == "WECHAT") {
        this.paying = false;
        this.weixingPay();
      }
    },
    // 微信支付
    weixingPay() {
      var _this = this;
      this.$put(
        `/order/api/order/${_this.$route.query.orderid}/pay?payWayEnum=${_this.payWayEnum}`
      ).then((res) => {
        if (res.code == 0) {
          _this.qrcode = res.data;
          _this.cycle = setInterval(() => {
            _this.getOrderInfo();
          }, 1000);
        } else {
          this.$message(res.message);
        }
      });
    },
    // 支付
    payClick() {
      var _this = this;
      if (this.payWayEnum == "WALLET") {
        if (this.$store.state.hasPwd) {
          this.dialogVisible = true;
        } else {
          var reg = /^(\d{3})\d{4}(\d{4})$/;
          this.phoneNum = this.$store.state.userPhone.replace(reg, "$1****$2");
          this.showPad = true;
        }
      } else {
        this.$put(
          `/order/api/order/${_this.$route.query.orderid}/pay?payWayEnum=${_this.payWayEnum}`
        ).then((res) => {
          if (res.code == 0) {
            localStorage.setItem("payHtml", res.data);
            _this.orderPay = true;
            let newPageHtml = window.open("about:blank");
            this.pathStr = process.env.VUE_APP_URL + "/pay";
            if (newPageHtml) {
              newPageHtml.location = this.pathStr;
              this.orderPay = true;
            } else {
              this.ispayHtml = true;
            }
            // let routeData = this.$router.resolve({
            //   name: "pay"
            // });
            // window.open(routeData.href, "_blank");
          } else {
            this.$message(res.message);
          }
        });
      }
    },
    // 支付未打开新页面情况下 dialog 关闭的回调
    payHtmlClose() {
      let timer = setTimeout(() => {
        this.orderPay = true;
        clearTimeout(timer);
      }, 300);
    },
    // 立即复制
    copyUrl(e) {
      this.$message.closeAll();
      const clipboard = new Clipboard(e.target, { text: () => this.pathStr });
      clipboard.on("success", (e) => {
        this.$message.success("复制成功");
        // 释放内存
        clipboard.off("error");
        clipboard.off("success");
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        this.$message.warning("该浏览器不支持自动复制，请手动复制");
        // 释放内存
        clipboard.off("error");
        clipboard.off("success");
        clipboard.destroy();
      });
      clipboard.onClick(e);
    },
    //验证码倒计时
    yzmTimeMinuse() {
      this.getYzm = false;
      let count = 60;
      this.yzmTime = 60;

      var auth_timetimer = setInterval(() => {
        this.yzmTime--;
        if (this.yzmTime <= 0) {
          this.getYzm = true;
          clearInterval(auth_timetimer);
          this.yzmTtext = "重新发送";
        }
      }, 1000);
    },
    // 余额支付
    clickPay() {
      var _this = this;
      _this.loading = true;
      this.$put(
        `/order/api/order/${_this.$route.query.orderid}/pay?payWayEnum=${_this.payWayEnum}&pwd=${_this.verificationCode}`
      ).then((res) => {
        if (res.code == 0) {
          _this.dialogVisible = false;
          _this.loading = false;
          _this.$router.push("/placeorder/stepthree");
        } else {
          this.$message(res.message);
          _this.loading = false;
        }
      });
    },
    // 获取订单详情
    getOrderInfo() {
      var _this = this;
      this.$fetch(`/order/api/order/${_this.$route.query.orderid}`).then(
        (res) => {
          if (res.code == 0) {
            // console.log(res.data.status)
            if (res.data.status != "WAIT_PAY") {
              this.$message({
                message: "支付成功",
                type: "success",
              });
              clearInterval(_this.cycle);
              setTimeout(() => {
                _this.$router.push("/user/order");
              }, 1000);
            }
          } else {
            // this.$message(res.message);
          }
        }
      );
    },
    passType(item) {
      var _this = this;
      if (item == "password") {
        _this.passwordType = "text";
      }
      if (item == "text") {
        _this.passwordType = "password";
      }
    },
    imgPreview(index) {
      this.imgindex = index;
      this.$refs.elimg.clickHandler();
    },
    navPrev() {
      if (this.move > 145) {
        this.move = this.move - 145;
      } else {
        this.move = 0;
      }
    },
    navNext() {
      if (
        this.move <
        this.dataNavListRealWidth - this.dataNavListViewWidth - 145
      ) {
        this.move = this.move + 145;
      } else {
        this.move = this.dataNavListRealWidth - this.dataNavListViewWidth;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/.el-input .el-input__suffix{
  width: auto !important;
}
</style>
<style lang="scss">
.order_payment {
  .el-dialog {
    width: 423px !important;
  }
  .el-input__inner {
    height: 40px !important;
  }
  .el-dialog__header {
    padding: 20px 45px 10px !important;
  }
  .el-dialog__body {
    padding: 5px 45px !important;
    position: relative;
    .icon {
      position: absolute;
      right: 45px;
      top: 15px;
      width: 19px;
      height: 19px;
      color: #c9cdd5;
      cursor: pointer;
    }
  }
  .el-dialog__footer {
    padding: 10px 45px 20px;
    margin-top: 10px;
  }
  .el-dialog__title {
    font-weight: bold;
  }
  .el-button {
    border-radius: 2px;
  }
  .el-button--primary {
    background: #3455d3;
    color: #fff;
    border-color: #3455d3;
    width: 60px;
    height: 28px;
    padding: 0 !important;
  }
  .el-button--primary:hover {
    background: #2c4abb;
    border-color: #2c4abb;
  }
  .el-button--default:hover {
    color: #3455d3;
    border-color: #3455d3;
    background: #fff;
  }
  .el-button--default {
    color: #bec0c6;
    border-color: #bec0c6;
    width: 60px;
    height: 28px;
    padding: 0 !important;
  }
  .el-dialog__headerbtn:hover .el-dialog__close {
    color: #3455d3;
  }
}
.zf_password {
  border-color: rgba(52, 85, 211, 0) !important;
  background: rgba(52, 85, 211, 0) !important;
}
.errpassword {
  color: #f75658;
  font-size: 12px;
  margin-top: 5px;
  position: absolute;
}
// .zfmima
</style>
<style lang="scss" scoped>
.qrcode {
  width: 250px;

  img {
    width: 250px;
    height: 250px;
    margin-left: -38px;
  }
  & > div {
    width: 250px;
    text-align: center;
    color: #2f3133;
    font-size: 14px;
    margin-left: -38px;

    span {
      font-weight: bold;
    }
  }
}
.step_title {
  height: 50px;
  padding: 0 63px;
  line-height: 50px;
  color: #2f3133;
  font-size: 18px;
  background: #f9fafa;
  border-bottom: 1px solid #dfe4eb;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  & > span {
    color: #5e6066;
    font-size: 12px;
    margin-left: 15px;
    .time {
      color: #f75658;
    }
  }
}
.pay {
  // height: 308px;
  background: #fff;
  padding: 30px 101px;
  .pay_modes {
    display: flex;
    justify-content: flex-start;
  }

  .pay_mode {
    width: 190px;
    height: 100px;
    background: rgba(249, 250, 250, 1);
    border-radius: 2px;
    border: 1px solid rgba(206, 212, 219, 1);
    padding: 20px 0 20px 22px;
    display: flex;
    margin-right: 12px;
    cursor: pointer;
    .icon {
      width: 56px;
      height: 56px;
      color: #b4b7bc;
      margin-right: 8px;
    }
  }
  .pay_mode_right {
    height: 56px;
    display: flex;
    flex-direction: column;
    font-size: 16px;
    color: #5e6066;
    justify-content: center;

    .yue_money {
      color: #ffad16;
      font-size: 12px;
    }
  }
  .pay_mode_right:nth-child(1) {
    justify-content: space-between;
    padding: 5px 0;
  }
  .pay_selected {
    background: rgba(243, 245, 253, 1);
    border: 1px solid rgba(52, 85, 211, 1);
    .pay_mode_right {
      color: #2f3133;
    }

    .icon {
      color: #3455d3;
    }
  }
  .pay_mode:hover {
    background: rgba(243, 245, 253, 1);
    border: 1px solid rgba(52, 85, 211, 1);
  }
}
.pay_total {
  margin-top: 50px;
  color: #2f3133;
  font-size: 14px;
  display: flex;
  align-items: center;
  .total_text {
    color: #f75658;
    font-size: 32px;
    display: inline-block;
    height: 32px;
    line-height: 1;
    margin-left: 12px;
  }
}
.payment {
  width: 190px;
  height: 46px;
  border-radius: 2px;
  font-size: 20px;
  color: #fff;
  background: rgba(52, 85, 211, 1);
  margin-top: 20px;
  border-color: #3455d3;
}
.payment:hover,
.payment:focus {
  color: #fff;
  background: rgba(52, 85, 211, 1);
}
.commodity_list {
  margin-top: 15px;
  background: #fff;
}
.com_items {
  padding: 20px 101px;
  position: relative;
  display: flex;
  .btn {
    width: 26px;
    height: 60px;
    background: rgba(0, 0, 0, 0.5);
    font-size: 11px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 55px;
    cursor: pointer;
    z-index: 1;
    &:hover {
      opacity: 0.7;
    }
  }
  .right-btn {
    right: 101px;
  }
  .left-btn {
    left: 101px;
  }
}
.commodity_item {
  height: 177px;
  color: #2f3133;
  font-size: 12px;
  // margin-right: 12px;
  overflow: hidden;
  display: flex;
  img {
    width: 129px;
    height: 129px;
    border-radius: 2px;
  }
  .dataNavListItem {
    width: 129px;
    display: inline-block;
    transition: transform 0.2s;
    margin-left: 16px;
    text-align: center;
    &:first-child {
      margin-left: 0;
    }
    & > span {
      margin-top: 12px;
      font-size: 12px;
      line-height: 16px;
    }
  }
}
.commodity_item:last-child {
  margin-bottom: 0;
}
.identity_tips {
  color: #909399;
  margin-top: -10px;
}

.order_payment {
  &/deep/.dialog-footer {
    .el-button--primary.is-disabled,
    .el-button--primary.is-disabled:active,
    .el-button--primary.is-disabled:focus,
    .el-button--primary.is-disabled:hover {
      background-color: #2c4abb;
      border-color: #2c4abb;
    }
  }
}
</style>

<style lang="scss" scoped>
.com_login{
  &/deep/.el-input input{
    height: 60px;
    border-radius: 0;
    border: none;
    border-bottom: 1px solid #dfe4eb;
    padding: 19px 0;
    color: #2f3133;
    &:hover{
      border-bottom: 1px solid #3455D3;
    }
  }
}

</style>
